import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbhp68psak: FaireProductEntity = {
  token: "p_cbhp68psak",
  type: "product",
  name: "Calendula Balm, plant based, soothing eczema \n& more",
  brandToken: "b_ad8bjvlw5g",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/af30ac548bc7817bbdcb9f5e311815a8132aa689ecfbcc1e70fce3a5499066b0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e161f203aeb7585d30b00b9e478414743eabdc4a344ba6085fc9806171e9d67f.jpeg",
    "https://cdn.faire.com/fastly/5395546c9fd5254d7c520698f8b011c3dd52f04265fbecfb59c6a8925ee01dae.jpeg",
    "https://cdn.faire.com/fastly/77312023f7541a74378584a376902023999ada356890460fab13434d87427e4e.jpeg",
    "https://cdn.faire.com/fastly/3abdd7a1cff98fbb88a60c64c8abb1ecc0560ef27f0549d29ea19bc86c68293a.jpeg",
    "https://cdn.faire.com/fastly/957e9d601b1e6192b211abbb8380ac8b058f60dfd83514465727b20639435880.jpeg",
    "https://cdn.faire.com/fastly/7c8a77552be337c5747c3ad89d6fb6b6b2e204110a31506ad763d546692c5d37.jpeg",
  ],
  priceDollars: 15.24,
  description:
    "✔️Plant Based ✔️Cruelty Free ✔️Eco Friendly\nCalendula is known for it's soothing properties and as a natural remedy for minor injuries such as scrapes and bruises. This Calendula balm is anti-inflammatory, anti-microbial and anti-fungal, it makes a great addition to any medicine cabinet and first aid kit. Also works well as a moisturizer!\n\nIngredients\nCalendula Infused Olive Oil, Coconut Oil, Evening Primrose Oil, Lavender Essential Oil, Beeswax, Vitamin E\nDirections\n\n- Use on bug bites, skin irritations, cuts and bruises.\n- Apply to diaper area to help treat and prevent diaper rash.\n- Massage into dry skin for relief from conditions such as eczema.\n- Balm is solid and melts on contact with skin.\n\nAs with many natural products, the tint of color may vary from batch to batch.\n***Product will come boxed unless otherwise specifically requested.***\n\nUnTamed Naturals does not make any medical claims. Please read ingredients before using. Always store natural products in a cool and dry place. For external use only.",
  tags: [],
  msrpDollars: 30.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:20.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
